import React from 'react';
import { Link } from 'react-router-dom';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/9hBG6bzycJ7d5ZCd9A6qzm/sin_fondo.png';
export function Header() {
  return <header className="fixed top-0 left-0 right-0 z-50 bg-black border-b border-[#6BB8D4]/15 pearl-border" data-id="element-113">
      <div className="max-w-6xl mx-auto px-6 h-16 flex items-center justify-between" data-id="element-114">
        <Link to="/" className="flex-shrink-0" data-id="element-115">
          <img src={LOGO_URL} alt="Rotterdam Barbería" className="h-16 w-auto" data-id="element-116" />
        </Link>

        <nav className="flex items-center gap-2 sm:gap-8" data-id="element-117">
          <a href="/#contact" className="text-[#6BB8D4] pearl-text hover:text-white text-[9px] sm:text-sm font-bold tracking-wide uppercase transition-colors duration-300" data-id="element-118">
            Ubicación
          </a>
          <a href="/#services" className="text-[#6BB8D4] pearl-text hover:text-white text-[9px] sm:text-sm font-bold tracking-wide uppercase transition-colors duration-300" data-id="element-119">
            Servicios
          </a>
          <a href="/#getting-ready" className="text-[#6BB8D4] pearl-text hover:text-white text-[9px] sm:text-sm font-bold tracking-wide uppercase transition-colors duration-300" data-id="element-120">
            Getting Ready
          </a>
          <a href="/#gift-cards" className="text-[#6BB8D4] pearl-text hover:text-white text-[9px] sm:text-sm font-bold tracking-wide uppercase transition-colors duration-300" data-id="element-121">
            Gift Cards
          </a>
        </nav>
      </div>
    </header>;
}